<template>
    <div> 
        <div class="form-group row">
            <label for="namegroup" class="col-md-4 col-form-label text-md-right">Όνομα Ομάδας</label>
            <div class="col-md-6">
                <input type="text" @change="updateGroupName" id="namegroup" class="form-control" placeholder="Εισάγετε όνομα ομάδας" name="namegroup">
            </div>
        </div>

        <div class="form-group row">
            <label for="description" class="col-md-4 col-form-label text-md-right">Περιγραφή</label>
            <div class="col-md-6">
                <input type="text" @change="updateGroupDescription" id="description" class="form-control" placeholder="Εισάγετε περιγραφή" name="description">
            </div>
        </div>

        <SearchEfedrosForm @error="onSearchError" :rows="rows"/>
    </div>
</template>

<script>
import SearchEfedrosForm from './SearchEfedrosForm'
export default {
    props: ['rows'],
    components: { SearchEfedrosForm },
    methods: {
        onSearchError: function(show_error, error_message){
            this.$emit('error', show_error, error_message)
            return;
        },
        updateGroupName: function(event) {
            this.$emit('updateGroupName', this.$validator.stripTags(event.target.value))
        },
        updateGroupDescription: function(event) {
            this.$emit('updateGroupDescription', this.$validator.stripTags(event.target.value))
        }
    }
}
</script>